import React from 'react';
import ReactDOM from 'react-dom/client';
import LanguageSwitcher from './components/LanguageSwitcher';
import App from './App';
import './styles/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LanguageSwitcher>
    <App />
  </LanguageSwitcher>
);